<template>
    <!-- Modal -->
    <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="documento || idGuias">
                <div class="modal-header">
                    <h5 class="modal-title">Zerodox - Selecione o tablet para assinatura</h5>
                    <button type="button" class="close" @click="fechar_modal(modal_id)" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="progress mt-1 mb-2" v-if="$store.state.loading">
                        <div class="indeterminate" v-if="$store.state.loading"></div>
                    </div>

                    <template>

                       <az-input
                            placeholder="Selecione o tablet"
                            label="Selecione o tablet"
                            type="select"
                            :optionsList="dispositivos"
                            optionsDisplay="nome"
                            optionsData="id"
                            v-model="dispositivo" />

                       <az-input
                            placeholder="cpf"
                            label="Informe o cpf"
                            type="cpf"
                            :edicao="!link"
                            v-model="cpf" />

                       <az-input
                            placeholder="Nome"
                            label="Nome"
                            :edicao="!link"
                            v-model="nome" />

                    </template>

                    <div v-if="forms && forms.length" class="mt-3">
                        <button type="button" class="btn btn-sm btn-outline-primary mb-2" @click="incluir_form()">
                            <i class="fa fa-plus mr-2" aria-hidden="true"></i> Formulário
                        </button>

                        <div class="form-row" v-for="(form, idx) in sel_forms" :key="idx">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Selecione o formulário..."
                                    type="select"
                                    :optionsList="forms"
                                    optionsDisplay="name"
                                    required
                                    :validate="validate"
                                    v-model="form.form">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" @click="sel_forms.splice(idx, 1)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal(modal_id)">
                        Fechar
                    </button>
                    <az-submit @click="assinar()" :disabled="link">Assinar</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
// import _ from "lodash";
import AzInput from "../shared/forms/AzInput.vue";
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() {
        return {
            documento: null,
            dispositivos: null,
            dispositivo: null,
            meio: 'dispositivo',
            email: null,
            cpf: null,
            nome: null,
            dt_nascimento: null, 
            nomeArquivo: null,
            unidade: "",
            operadora: "",
            chave_assinatura: "",
            qtd_ocor_ass: 0,
            obter_link: false, 
            link: null, 
            validate: false, 
            idGuias: null,
            uuidModal: null,
            other_model_id : null,
            other_model_type : null,
            other_id_atendimento : null,
            forms: [], 
            sel_forms: [], 
            id_modelo_documento_selec: null, 
        };
    },

    props: ['model_id', 'model_type', 'id_modelo_documento'],

    components: {
        AzInput,
        AzSubmit
    },

    computed: {
        modal_id: function () {
            return 'zerodoxModal' + this.uuidModal;
        },
    },

    methods: {
        // copiar_clipboard () { 
        //     this.$util.copiar_clipboard(
        //         this, 
        //         this.link,
        //         'Link copiado.'
        //     );
        // },

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },  

        incluir_form () { 
            this.sel_forms.push({ form: "" });
        },

        load() {
            this.dispositivos = [];
            this.forms = []; 
            this.sel_forms = []; 

            this.$util.load(this, {
                service: "zerodox",
                func: "dispositiivos",
                redir_api: true, 
                parms: {
                    model_type: this.model_type,
                    model_id: this.model_id,
                },
                toast: false,
                loadTo: res => {

                    if ( res.msg ) { 
                        this.$toast.add({
                            severity: "warn",
                            summary: "Zerodox",
                            detail: res.msg,
                            life: 5000
                        });
                    }

                    console.log('res', res);

                    if(res && res.dispositivos) {
                        this.dispositivos = res.dispositivos;
                    }

                    if(res && res.forms && res.forms.length ) {
                        this.forms = res.forms;
                    }
                }
            });

            this.dispositivo = this.$util.getCookie('dispositivo-zerodox');
        },

        show(documentoBase64, nomeArquivo, email, cpf, nome, unidade = "", operadora = "", dt_nascimento = "", model_id = null, model_type = null, id_atendimento = null, id_modelo_documento = null) {
            this.validate = false;

            this.load();

            if(nomeArquivo && nomeArquivo != '') {
                this.nomeArquivo = nomeArquivo.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            } else {
                this.nomeArquivo = 'documento_zerodox';
            }

            this.documento = documentoBase64;
            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.id_modelo_documento_selec = id_modelo_documento;
            this.link = "";

            if (model_id && model_type) {
                this.other_model_id = model_id;
                this.other_model_type = model_type;
                this.other_id_atendimento = id_atendimento;
            }
            
            $("#" + this.modal_id).modal("show");
        },
        
        show_guias(idGuias, email, cpf, nome, unidade = "", operadora = "", dt_nascimento = "") {
            this.validate = false;

            this.load();
            
            this.documento = '';
            this.nomeArquivo = 'guia_zerodox';
            this.idGuias = idGuias

            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.id_modelo_documento_selec = null; 

            $("#" + this.modal_id).modal("show");
        },

        assinar() {
            this.$util.setCookie('dispositivo-zerodox', this.dispositivo);

            this.$util.atualizar(this, {
                service: "zerodox",
                func: "assinar",
                redir_api: true, 
                dados: {
                    model_id: this.other_model_id ? this.other_model_id : this.model_id,
                    model_type: this.other_model_type ? this.other_model_type : this.model_type,
                    pdf: this.documento,
                    nome_arquivo: this.nomeArquivo,
                    id_dispositivo: this.dispositivo,
                    email: this.email,
                    cpf: this.cpf,
                    nome: this.nome,
                    dt_nascimento: this.dt_nascimento, 
                    unidade: this.unidade,
                    operadora: this.operadora,
                    id_modelo_documento: this.id_modelo_documento_selec ? this.id_modelo_documento_selec : this.id_modelo_documento,
                    id_guias: this.idGuias,
                    id_atendimento : this.other_id_atendimento,
                    forms: this.sel_forms.map(item => item.form),
                },
                toast: false,
                callback: res => {
                    if(res && res.status_code == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Atualizar",
                            detail: res.msg ? res.msg : "Documento enviado com sucesso",
                            life: 3000
                        });
                    }

                    $("#" + this.modal_id).modal("hide");
                }
            });
        }
    },
    
    mounted() {
        const uuid = this.$util.uuidv4();
        this.uuidModal = uuid;
    },

};
</script>
